import {
  iconBatteryUnknown,
  iconBatteryFull,
  iconBatteryThreeQuarter,
  iconBatteryHalf,
  iconBatteryLittle,
  iconBatteryEmpty,
} from '../icons'

export const getBatteryImageSrc = (percentage?: number | null): string => {
  if (percentage == null) {
    return iconBatteryUnknown
  }

  switch (true) {
    case percentage >= 75:
      return iconBatteryFull
    case percentage > 50:
      return iconBatteryThreeQuarter
    case percentage >= 25:
      return iconBatteryHalf
    case percentage >= 5:
      return iconBatteryLittle
    default:
      return iconBatteryEmpty
  }
}

export const getBatteryPercentageText = (percentage?: number | null): string => {
  if (percentage == null) {
    return '-'
  }

  return `${percentage}%`
}
